import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import { useEnableEndUserRequestUpgrade } from '@confluence/experiment-confluence-enable-end-user-request/entry-points/useEnableEndUserRequestUpgrade.ts';

import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery.ts';
import type { ChangeEditionSectionMessageProps } from '../SectionMessage/ChangeEditionSectionMessage.tsx';
import { SectionMessage } from '../UpsellLooknFeel/SectionMessage.tsx';

export type CopySpacePermissionsUpsellProps = Pick<
	ChangeEditionSectionMessageProps,
	'appearanceType' | 'source' | 'onRequestUpgradeButtonClick' | 'requestUpgradeButtonIsLoading'
> & {
	messages: Record<'body' | 'title', MessageDescriptor>;
};

export const CopySpacePermissionsUpsell = ({
	messages,
	...props
}: CopySpacePermissionsUpsellProps) => {
	const { showRequestUpgradeButton, loading } = useEnableEndUserRequestUpgrade(props.source);
	return (
		<TransparentErrorBoundary attribution={Attribution.PERMISSIONS_EXPERIENCE}>
			<SectionMessage
				{...props}
				title={<FormattedMessage {...messages.title} />}
				body={<FormattedMessage {...messages.body} tagName="p" />}
				targetEdition={ConfluenceEdition.PREMIUM}
				isLoadingRequestUpgradeButton={loading}
				showRequestUpgradeButton={showRequestUpgradeButton}
				learnMoreLink={{
					actionSubjectId: 'copySpacePermissionsUpsellLearnMore',
					href: 'https://support.atlassian.com/confluence-cloud/docs/copy-space-permissions/',
				}}
				upgradeEditionActionSubjectId="copySpacePermissionsUpsellTryNow"
				withGradient={false}
			/>
		</TransparentErrorBoundary>
	);
};
